<template>
    <div class="company-honors-container">

        <div class="honors-block">
            <div class="honors-block-title page-block-title">企业荣誉</div>
            <div class="honors-row">
                <div class="row-item-box">
                    高新技术企业
                </div>
                <div class="row-item-box">
                    国家双软企业
                </div>
                <div class="row-item-box">
                    领军人才企业
                </div>
                <div class="row-item-box">
                    民营科技企业
                </div>
                <div class="row-item-box">
                    通用航空企业
                </div>
            </div>

            <div class="honors-list">
                <div class="list-item" v-for="(item, index) in honorsList" :key="index">
                    <img v-if="index != honorsList.length - 1"
                        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/honor_icon.png"
                        alt="">
                    <div class="item-title">{{ item.title }}</div>
                </div>
            </div>

            <div class="honors-page">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/certificate.png"
                    alt="">
            </div>
        </div>
        <div class="patent-block">
            <div class="honors-block-title page-block-title">专利软著</div>
            <!-- <div class="img-wrap">
            </div> -->
            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/certificate4.png"
                class="mobile-img">
            <img class="pc-img"
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/certificate_bg.png"
                alt="">
        </div>
    </div>
</template>




<script>
export default {
    data() {
        return {
            honorsList: [
                {
                    title: "国家高新技术企业"
                },
                {
                    title: "江苏省民营科技企业"
                },
                {
                    title: "软件产品证书"
                },
                {
                    title: "软件企业证书"
                },
                {
                    title: "苏州高新区科技创业领军人才企业"
                },
                {
                    title: "姑苏创新创业领军人才企业"
                },
                {
                    title: "诚信经营示范单位"
                },
                {
                    title: "诚信供应商企业"
                },
                {
                    title: "通用航空企业经营资质"
                }, {
                    title: "智汇苏高新创新创业大赛 第一名"
                },
                {
                    title: "ISO质量管理体系认证"
                },
                {
                    title: "职业健康安全管理体系认证"
                },
                {
                    title: "环境管理体系认证"
                },
                {
                    title: "2023好光伏“年度新锐企业”奖"
                },
                {
                    title: ""
                },
            ]
        }
    }
}
</script>

<style lang="stylus" scoped>
.company-honors-container {
    .honors-block {
        max-width:var(--main-width);
    width:84%;
        margin:0 auto;
        .honors-block-title {
            position:relative;
            color:#333;
            text-align: center;
            margin-top:4rem;
            font-weight:bold;
            letter-spacing:2px;
        }
        .honors-row {
            display:flex;
            margin-top:5.43rem;
            margin-bottom:3.8rem;
            justify-content: center;
            white-space:nowrap;
            div {
                margin-right:2.375rem;
                width:209px;
                min-width:173px;
                height:68px;
                font-size:1.5rem;
                font-weight:bold;
                line-height:68px;
                text-align:center;
                background-size: 100%;
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/honors_text_bg.png");
                background-repeat: no-repeat;
            }
        }
        .honors-list {
            display:flex;
            flex-wrap:wrap;
            margin-bottom:5.5rem;
            justify-content:center; 
            // justify-content: space-between;
            .list-item {
                width:33%;
                margin-bottom:20px;
                font-size:1.125rem;
                color:#333;
                display:flex;
                white-space: nowrap;
                align-items: center;
                min-width:293px;
                img {
                    margin-right:8px;
                }
            }
        }
        .honors-page {
            display:flex;
            justify-content:center;
            .mobile-img {
                display:none;
            }
            img {
                max-width:55rem;
            }
        }
    }
    .patent-block {
        width:100%;
        vertical-align:middle;
        img {
            width:100%;
            display:block;
        }
        .mobile-img {
            display:none;
        }
        .honors-block-title {
            position:relative;
            color:#333;
            font-weight:bold;
            letter-spacing:2px;
            text-align: center;
            margin-top:4rem;
        }
        .img-wrap {
            background: url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/certificate_bg.png");
            background-size: cover;
            width: 100%;
            background-repeat: no-repeat;
            height:68.125rem;
        }
    }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
    // .content-box-top-banner {
    //     height:16.75rem !important;
    // }
    .honors-page {
        img {
          width:30rem !important;
        }
    }
    .honors-list {
        padding: 0 30px;
    }
    .row-item-box {
        margin-bottom:5px;
    }
}
@media only screen and (max-width: 768px) {
    // .content-box-top-banner {
    //     height:16.75rem !important;
    // }
    .company-honors-container {
    .patent-block {
        .honors-block-title {
            margin-bottom:20px;
            font-size:22px;
        }
        .pc-img {
            display:none;
        }
        .mobile-img {
            display:block;
        }
    }
     .honors-block {
       .honors-page {
           img {
             width:80%;
           }
       }
       .honors-list {
        display:none;
    }
       .honors-row {
        flex-wrap:wrap;
        margin-top:51px;
        margin-bottom:13px;
    }
    .honors-row div {
        width:140px;
        min-width:auto ;
        line-height:55px;
    }
    .honors-row div:nth-child(2n) {
        margin-right:0 !important;
    }
   }
   
 
    .row-item-box {
        margin-bottom:5px;
        font-size:18px !important;
    }
}

  

}
</style>
